module.exports = __webpack_public_path__ + "static/media/more-horizontal.f712d2df.svg";